const serviceProviders = {
  serviceProviderList: 'Service providers',
  list: {
    search: 'Search for a service provider',
    noDataSubTitle: 'There are no service provider to display yet',
    noDataDescription: 'Start now to add service provider',
    category: 'Category',
    branches: 'Branches',
    addBranch: 'Add branch',
    generatePassword: 'Generate password',
    CreateButton: 'Add a new service provider',
    editStatus: 'Edit status',
    filter: {
      filtersPlaceHolders: {
        filterByCategory: 'Category',
        filterByProviderStatus: 'status',
      },
    },
    suspendedByBlock: 'This provider will be blocked once all appointments are completed',
    suspendedByDeactivateProvider: 'This provider will be deactivated starting from',
    status: {
      active: 'Active',
      deactivated: 'Deactivated',
      blocked: 'Blocked',
      suspended: 'Suspended',
      unpublished: 'Unpublished',
      requestedPublishing: 'Requested publishing',
    },
    statusActions: {
      activate: 'Activate',
      block: 'Block',
      deactivateNow: 'Deactivate immediately',
      deacivateLater: 'Deactivate starting from a certain date',
      deacivateLaterTitle: 'Deactivate Service Provider',
      dateLabel: 'Starting from',
    },
    blockProviderHint:'The provider will be suspended until completing any ongoing bookings & then will be automatically blocked'
  },
  addServiceProvider: {
    title: 'Add new service provider',
    labels: {
      email: 'Email',
      CommercialRegistrationNumber: 'Commercial Registration (CR) / Freelancing Certificate / Residence number',
      ExpiryDate: 'Expiry date',
      UploadCR: 'Upload The Commercial Registration (CR) / Freelancing Certificate / Proof of residence',
      acceptedFilesImgPdf:"Max size: 5MB, accepted formats: pdf, jpg, jpeg, png",
      joiningDate:"Joining date",
      iban:"IBAN",
      contract:"Upload contract",
      enDescription:'Description (En)',
      arDescription:'Description (Ar)',
    },
    placeholders: {
      email: 'Enter email',
      ArName: 'Enter arabic name',
      EnName: 'Enter english name',
      category: 'Choose category',
      uploadLogo: 'Logo',
      banner: 'Banner',
      mimarCommission: "Mimar's commission",
      CommercialRegistrationNumber:"Enter CR, Freelancing Certificate or Residence number",
      ExpiryDate:"Enter expiry date",
      UploadCR:"Upload CR, Freelancing Certificate or Proof of residence",
      commissionFixedFees:"Enter fixed fees",
      mimarPercentage:"Enter percentage",
      joiningDate:"Enter joining date",
      iban:"Enter IBAN",
      contract:"Upload contract",
      enDescription:'Describe your business in English',
      arDescription:'Describe your business in Arabic',
    },
    mimarCommissionOptions:{
      percentage:"Percentage",
      fixed_fees:"Fixed fees"
    }
  },
  editServiceProvider: {
    title: 'Edit service provider',
    confirmChangeCommissionTitle: "Change Mimar's commission confirmation",
    confirmChangeFixedFeesCommissionMessage: "Fixed fees commission will not affect the current month's settings and will only take effect starting from the next month",
    confirmChangePercentageCommissionMessage: "Percentage fees commission will not affect the current month's settings and will only take effect starting from the next month",
    confirmChangePercentageCommissionValueMessage: "The updated commission will take place on the upcoming payments",
  },
  deleteServiceProvider: {
    title: 'Delete service provider',
    deleteConfirmationMsg: 'Are you sure you want to delete this Service Provider? ',
  },
  viewServiceProvider: {
    title: 'Service provider details',
    noProvider: 'no providers are added yet',
    showPasswordTitle: 'Password details',
    passwordIs: "Service provider's password is: ",
    generatePassword: 'Generate random passowrd',
    noBranches: 'No branches are added yet',
    commissionType: 'Commission Type',
    comissionValue: 'Commission Value',
    joiningDate: 'Joining Date',
    contract: 'Contract',
    verificationDocument: 'Verification Document',
    verificationDocumentTooltip: 'CR / Freelancing Certificate / Proof of residence',
    documentNumber: 'Document Number',
    documentExpiry: 'Document Expiry',
    iban: 'IBAN',
    SR: 'SR',
    perTransaction: 'Per transaction',
    billedMonthly: 'Billed monthly',
  },
  CommissionTooltip: 'Note that this is the commission that will be applied on this provider',
};

export default serviceProviders;
